import request from './base'

export default {
  /**
   * 产品列表
   * params: {
   *  pageNum: 1,
   *  pageSize: 10,
   *  queryType：1,
   *  dto: {
   *    status: ''
   *   }
   * }
   */
  getProList: (commit, payload, mutation) => {
    let options = request.getOptions('/product/page', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 产品添加 编辑
   * params: {
   *  type: 1,
   *  dto: {
   *    productName: '产品名称',
   *    crowd: '适应人群',
   *    term: '保障期限',
   *    bright: '产品亮点/特点',
   *    image: '产品封面图',
   *    price: '产品价格',
   *    commissionDiscount: '产品返佣',
   *    introduction: '产品简介',
   *    telphone: '联系电话',
   *    reason: '未通过原因'
   *  }
   * }
   */
  updatePro: (commit, payload, mutation) => {
    let options = request.getOptions('/product/addorupdate', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 产品删除
   * params: {
   *  type: 5,
   *  dto: {
   *    productId: null,
   *    rzProductId: null
   *  }
   * }
   */
  deletePro: (commit, payload, mutation) => {
    let options = request.getOptions('/product/delete', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构添加 编辑公司简介状态 code=GSJJ    编辑联系我们状态 code=GSJJ     编辑官方信息     code=GFXX
   */
  addorupdate: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/addorupdate', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 机构详情
   */
  partnerQuery: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/query', payload)
    return request.post(commit, options, mutation)
  },
  /**
     * 获取团队风采 图集
     * params: {
     *  pageNum: 1,
     *  pageSize: 10,
     *  partnerId: 10000,
     *  dto: {
     *    status: '',
     *    type: 1  1 团队风采，2 荣誉资质
     *  }
     * }
     */
  getAtlas: (commit, payload, mutation) => {
    let options = request.getOptions('/atlass/page', payload)
    return request.post(commit, options, mutation)
  },
  /**
     * 删除图集
     * params: {
     *  dto: {
     *    atlasId: null,
     *    status: 9
     *  }
     * }
     */
  deleteAltas: (commit, payload, mutation) => {
    let options = request.getOptions('/atlass', payload)
    return request.put(commit, options, mutation)
  },
  /**
     * 删除图片
     * params: {
     *  dto: {
     *    atlasId: null,
     *    status: 9
     *  }
     * }
     */
  imagestemps: (commit, payload, mutation) => {
    let options = request.getOptions('/imagestemps', payload)
    return request.put(commit, options, mutation)
  },
  /**
     * 删除图集
     * params: {
     *  dto: {
     *    atlasId: null,
     *    status: 9
     *  }
     * }
     */
  addAltas: (commit, payload, mutation) => {
    let options = request.getOptions('/atlass', payload)
    return request.post(commit, options, mutation)
  },
  /**
     * 添加图片
     * params: {
     *  dto: {
     *    atlasId: null,
     *    status: 9
     *  }
     * }
     */
  addimagestemps: (commit, payload, mutation) => {
    let options = request.getOptions('/imagestemps', payload)
    return request.post(commit, options, mutation)
  },
  /**
     * 删除图集
     * params: {
     *  dto: {
     *    atlasId: null,
     *    status: 9
     *  }
     * }
     */
  imagestempsQuery: (commit, payload, mutation) => {
    let options = request.getOptions('/imagestemps/query', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 添加保险公司
   * @param {*} commit
   * @param {*} payload
   * @param {*} mutation
   * @returns
   */
  partnerAdd: (commit, payload, mutation) => {
    let options = request.getOptions('/partner/add', payload)
    return request.post(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/company.js